import en from "./locale/en";
import ru from "./locale/ru";
import pt from "./locale/pt";

export default {
  en,
  ru,
  pt
};
